import { DatePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserClientAssignment } from '../../../api/app-types/assignment';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { matDateProviders } from '../../../shared/helpers/date.func';
import { MatChip } from '@angular/material/chips';

export type AssignmentRowVariant = 'default' | 'newStatus' | 'finished';
export type AssignmentItemToggleEvent =
	| {
			kind: 'assignment';
			clientId: number;
			assignment: UserClientAssignment;
			checked: boolean;
	  }
	| {
			kind: 'fds';
			clientId: number;
			checked: boolean;
	  };

@Component({
	selector: 'lvr-user-client-assignment-item',
	template: `
		<div class="assignment-row" [class.assignment-row--status-neu]="variant() === 'newStatus'">
			@if (showCheckbox()) {
				<label class="assignment-check">
					<input
						type="checkbox"
						[checked]="checked()"
						[disabled]="disabled()"
						(change)="onToggle($any($event.target).checked)"
					/>
				</label>
			} @else {
				<span class="assignment-check spacer"></span>
			}

			<div class="assignment-content">
				<div class="assignment-info">
					<div class="assignment-info">
						@if (itemType() === 'fds') {
							<span class="strong">FDS</span>
							<span>|</span>
							<span class="strong">{{ 'user.assignment_transfer.new_status' | transloco }}</span>
						} @else if (variant() === 'newStatus') {
							<span class="strong">{{ assignment()?.assignmentType }}</span>
							<span>|</span>
							<span class="strong">{{ 'user.assignment_transfer.new_status' | transloco }}</span>
						} @else {
							<span class="strong">{{ assignment()?.assignmentType }}</span>
							<span>|</span>
							<span class="strong">{{ assignment()?.phase }}</span>
						}

						@if (variant() === 'finished') {
							<span class="gap"></span>
							<mat-chip class="chip-default">{{ 'user.assignment_transfer.completed' | transloco }}</mat-chip>
						}

						@if (!hideDate()) {
							<span class="gap"></span>
							<span class="strong">{{ 'user.assignment_transfer.date' | transloco }}</span>
							<span>{{ (assignment()?.currentPhaseStart | date: 'dd.MM.yyyy') || '--' }}</span>
						}

						@if (!hideNumber()) {
							<span class="gap"></span>
							<span class="strong">{{ 'user.assignment_transfer.assignment_number' | transloco }}:</span>
							<span>{{ assignment()?.assignmentGuid || '--' }}</span>
						}

						@if (ownerLabel()) {
							<span class="gap"></span>
							<span class="strong">{{ ownerLabel() }}</span>
							<span>{{ assignment()?.ownerFullName || '--' }}</span>
						}
					</div>
				</div>
			</div>
		</div>
	`,
	styleUrl: './user-assignment-transfer.scss',
	imports: [TranslocoPipe, DatePipe, MatDatepickerModule, MatInputModule, MatChip],
	providers: [matDateProviders],
})
export class UserClientAssignmentItem {
	public readonly clientId = input.required<number>();
	public readonly assignment = input<UserClientAssignment | null>();
	public readonly checked = input(false);
	public readonly disabled = input(false);
	public readonly variant = input<AssignmentRowVariant>('default');
	public readonly showCheckbox = input(true);
	public readonly hideDate = input(false);
	public readonly hideNumber = input(false);
	public readonly ownerLabel = input('Falleigner:');
	public readonly itemType = input<'assignment' | 'fds'>('assignment');

	public readonly toggled = output<AssignmentItemToggleEvent>();

	public onToggle(checked: boolean) {
		if (this.itemType() === 'fds') {
			this.toggled.emit({
				kind: 'fds',
				clientId: this.clientId(),
				checked,
			});
			return;
		}

		const assignment = this.assignment();
		if (!assignment) return;

		this.toggled.emit({
			kind: 'assignment',
			clientId: this.clientId(),
			assignment,
			checked,
		});
	}
}
